import React, { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import General from './ReportParts/General'
import CampaignOverview from './ReportParts/CampaignOverview'
import ImportantMetrics from './ReportParts/ImportantMetrics'
import SurveyLink from './ReportParts/SurveyLink'
import Contact from './ReportParts/Contact'
import LearningRecommendation from './ReportParts/LearningRecommendation'
import SharedCampaignReportTimeline from './ReportParts/SharedCampaignReportTimeline'
import InfluencerOverview from './ReportParts/InfluencerOverview'
import AudienceMetrics from '../../../ProjectManager/Campaign/CampaignPageParts/ReportParts/AudienceMetrics'
import { SharedCampaignContext } from '../../../../contexts/Advertiser/SharedCampaignContext'
import { useSidebarCollapse } from '../../../../contexts/SidebarCollapseContext'

export default observer(function CampaignReport() {
  const { campaignReport, selectedScenario, campaign } = useContext(SharedCampaignContext)
  const { isCollapsed } = useSidebarCollapse()

  return (
    <div className={`w-full h-full bg-rb-grey dark:bg-rb-dark-mode-background flex justify-center items-center transition-all duration-300 ${isCollapsed ? 'pl-16' : 'pl-56'}`}>
      <div className='w-[800px] h-full pt-10'>
        <h1 className='font-bold text-2xl mb-5 dark:text-white'>Campaign Reporting & Performance Monitoring</h1>
        <div className="flex flex-col gap-4 pb-4">
          {campaignReport.general_visible && <General campaignName={campaignReport.campaign_name} />}
          {campaignReport.campaign_overview_visible && <CampaignOverview timeframeVisible={campaignReport.timeframe_visible} defaultOverview={campaignReport.default_campaign_overview_sections} customOverview={campaignReport.custom_campaign_overview_sections} startDate={campaignReport.start_date} endDate={campaignReport.end_date} />}
          {campaignReport.important_metrics_visible && <ImportantMetrics campaignReport={campaignReport} />}
          {campaignReport.influencer_overview_visible && <InfluencerOverview selectedScenario={selectedScenario} influencerPerformances={campaignReport.report_influencer_performances} />}
          {campaignReport.audience_metrics_visible && <AudienceMetrics advSideScenario={selectedScenario} campaignReport={campaignReport}/>}
          {campaignReport.timeline_visible && selectedScenario?.timeline_visible && <SharedCampaignReportTimeline />}
          {campaignReport.learning_visible && <LearningRecommendation learningSections={campaignReport.learning_sections} />}
          <SurveyLink title={campaignReport.survey_link_title} link={campaignReport.survey_link} />
          {campaignReport.contact_us_visible && <Contact campaign={campaign}/>}
        </div>
      </div>
    </div>
  )
})